<template>
  <div
    style="padding: 10px 10px 10px 10px;border: #9e9e9e solid 1px">
    <div
      v-if="showItem"
    >
      <v-progress-linear
        class="ma-0"
        v-model="minItemProgress"
        :color="minItemColor"
        height="5"
        background-color="grey lighten-2"
      >
      </v-progress-linear>
      <v-card-text
        class="ma-0 pa-0"
        :style="textStyle"
      >{{ minItemText }}
      </v-card-text>
    </div>
    <div
      v-if="showPrice"
    >
      <v-progress-linear
        class="ma-0"
        v-model="minPriceProgress"
        :color="minPriceColor"
        height="5"
        background-color="grey lighten-2"
      >
      </v-progress-linear>
      <v-card-text
        class="ma-0 pa-0"
        :style="textStyle"
      >{{ minPriceText }}
      </v-card-text>
    </div>
    <div
      v-for="(d) in deliveryConfig.discountData"
    >
      <delivery-discount-bar :discountdata="d"></delivery-discount-bar>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import DeliveryDiscountBar from '../components/DeliveryDiscountBar'

export default {
  name: 'delivery-progress-bar',
  components: { 'delivery-discount-bar': DeliveryDiscountBar },
  data () {
    return {
      freeDelivery: null,
      deliveryDiscount: [],
    }
  },
  computed: {
    ...mapGetters('config', [
      'deliveryConfig', 'theme'
    ]),
    ...mapGetters('cart', [
      'cart', 'cartItemDialog', 'cartAmount', 'cartQty', 'pickupTime'
    ]),
    showPrice () {
      return this.deliveryConfig.minType === 2 || this.deliveryConfig.minType === 3
    },
    showItem () {
      return this.deliveryConfig.minType === 1 || this.deliveryConfig.minType === 3
    },
    showDeliveryDiscount () {
      // got free delivery
      if (this.deliveryConfig.discountData.length > 0){
        this.deliveryConfig.discountData.forEach((discount) => {
          if(parseInt(discount.discount_percentage) === 100) {
            this.freeDelivery = discount
          }
        });
      }
      return this.freeDelivery
    },
    minItemProgress () {
      if (this.cartQty > this.deliveryConfig.minItems) return 100
      else return this.cartQty / this.deliveryConfig.minItems * 100
    },
    minPriceProgress () {
      if (this.cartAmount > this.deliveryConfig.minPrice) return 100
      else return this.cartAmount / this.deliveryConfig.minPrice * 100
    },
    deliveryDiscountProgress () {
      if (this.cartAmount > this.freeDelivery.minimum_amount) return 100
      else return this.cartAmount / this.freeDelivery.minimum_amount * 100
    },
    minItemText () {
      if (this.minItemProgress === 100) {
        return 'Yahoo! You have hit min order of ' + this.deliveryConfig.minItems + ' items!'
      } else {
        let diff = this.deliveryConfig.minItems - this.cartQty
        return 'Add ' + diff + ' more items to min order of ' + this.deliveryConfig.minItems + ' items'
      }
    },
    minPriceText () {
      if (this.minPriceProgress === 100) {
        return 'Yahoo! You have hit min order of $' + this.deliveryConfig.minPrice.toFixed(2) + '!'
      } else {
        let diff = parseFloat(this.deliveryConfig.minPrice) - parseFloat(this.cartAmount)
        return 'Add $' + diff.toFixed(2) + ' more to min order of $' + this.deliveryConfig.minPrice
      }
    },
    deliveryDiscountText () {
      if (this.deliveryDiscountProgress === 100) {
        return 'Yahoo! You may enjoy free delivery now!'
      } else {
        let diff = this.freeDelivery.minimum_amount - this.cartAmount
        diff = (Math.ceil(diff*20)/20).toFixed(2)
        return 'Add $' + diff + ' more for free delivery!'
      }
    },
    minItemColor () {
      if (this.minItemProgress === 100) {
        return 'green'
      } else if (this.minItemProgress >= 50) {
        return 'amber'
      } else {
        return 'red'
      }
    },
    minPriceColor () {
      if (this.minPriceProgress === 100) {
        return 'green'
      } else if (this.minPriceProgress > 50) {
        return 'amber'
      } else {
        return 'red'
      }
    },
    deliveryDiscountColor () {
      if (this.deliveryDiscountProgress === 100) {
        return 'green'
      } else if (this.deliveryDiscountProgress >= 50) {
        return 'amber'
      } else {
        return 'red'
      }
    },
    textStyle () {
      let color = this.theme.delivery_condition_text_color ? this.theme.delivery_condition_text_color : 'black'
      return {
        color: color,
        fontSize: '12px'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DeliveryProgressBar.vue